<script setup lang="ts">
import GamesTable from '@/views/pages/games/GamesTable.vue'

definePage({
  meta: {
    action: 'read',
    subject: 'games',
  },
})
</script>

<template>
  <GamesTable
    show-add-button
    :for-participant="false"
    :for-expert="false"
    :player-id="null"
  />
</template>

<style lang="scss">
.ProseMirror-focused{
  border: none;
}
</style>
